/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as React from 'react';
import { IBrandCmsViewProps } from './brand-cms';
// @ts-ignore
import Slider from 'react-slick';
export default (props: IBrandCmsViewProps) => {
    const allBrandsRecordId = 5637144824;

    const OfferBrandCategory =
        props.data.categories?.result &&
        props.data.categories?.result.filter(line => {
            return line.RecordId === 5637144701;
        });
    const brandCategory =
        OfferBrandCategory &&
        OfferBrandCategory?.length > 0 &&
        OfferBrandCategory[0]?.Children &&
        OfferBrandCategory[0].Children.filter(line => {
            return line.RecordId === allBrandsRecordId;
        });
    const brandData = brandCategory && brandCategory.length > 0 && brandCategory[0]?.Children ? brandCategory[0]?.Children : [];
    let brandList = [];
    const base_image_url = 'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/vnnhvggtsx/imageFileData/'; //process.env.MSDyn365Commerce_CMSIMAGEBASEURL;
    for (let i = 0; i < brandData.length; i++) {
        // @ts-ignore
        const image = brandData[i].Images.length > 0 && brandData[i].Images[0].Uri;
        const url = image
            ? `${base_image_url}search?fileName=/${image}&w=134&h=134&m=6&cropfocalregion=true`
            : `${base_image_url}MDfBO?pubver=1`;
        let name = `${brandData[i]?.Name}`;
        name = name.toLowerCase();

        const link = `/${brandData[i]?.Name}/${brandData[i]?.RecordId}.c`;
        var obj = {
            image_url: url,
            name: name,
            link: link,
            display_order: brandData[i].DisplayOrder
        };
        brandList.push(obj);
    }
    const brandsData = brandList && brandList.length > 0 ? brandList.slice(0, 10) : [];
    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 9,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 1000,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 9
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    };

    return (
        <>
            <div className='container'>
                <h2 className='category-header'>Shop by brand</h2>
            </div>
            <Slider {...settings} className='container brand-slider brand'>
                {brandsData.map((card: any, index: number) => (
                    <div key={index}>
                        <a href={card.link}>
                            <img src={card.image_url} width='100' height='100' />
                        </a>
                    </div>
                ))}
            </Slider>
        </>
    );
};
